import type { BorderRadiusToken } from "./borderRadius/borderRadiusTokens";
import { borderRadiusTokens } from "./borderRadius/borderRadiusTokens";
import type { BoxShadowToken } from "./boxShadows/boxShadowsTokens";
import { boxShadowTokens } from "./boxShadows/boxShadowsTokens";
import type { ColorToken } from "./colors/tokens/colorTokens";
import { colorTokens } from "./colors/tokens/colorTokens";
import type { ColorValue } from "./colors/values/colorValues";
import { colorValues } from "./colors/values/colorValues";
import { fontTokens } from "./fonts/fontTokens";
import type { FontToken } from "./fonts/fontTokens";
import type { LayoutToken } from "./layout/layoutTokens";
import { layoutTokens } from "./layout/layoutTokens";
import { screenSizeTokens } from "./screenSize/tokens/screenSizeTokens";
import type { SpacingToken } from "./spacing/spacingTokens";
import { spacingTokens } from "./spacing/spacingTokens";

/**
 * Tokens that can be used as a css key.
 */
export const keyTokens = { ...screenSizeTokens };
export type KeyToken = keyof typeof keyTokens;

/**
 * Tokens that can be used as a css value.
 */
export const valueTokens = {
  ...colorValues,
  ...colorTokens,
  ...spacingTokens,
  ...boxShadowTokens,
  ...borderRadiusTokens,
  ...layoutTokens,
  ...fontTokens,
};

export type {
  BorderRadiusToken,
  BoxShadowToken,
  ColorToken,
  ColorValue,
  FontToken,
  LayoutToken,
  SpacingToken,
};
